import { useQuery, gql } from '@apollo/client';
import { partition } from 'lodash';
import useNewProjectTask from './useNewProjectTask';
import { combineExistingTasksWithNewTask } from './helpers';

export const GET_ASSET_PROJECT_TASKS = gql`
  query GetAssetProjectTasks($id: ID!) {
    projectTasksForResource(id: $id) {
      id
      position
      details
      completed
      completedAt
      completedBy {
        id
        name
      }
    }
  }
`;

export const GET_PROJECT_TASKS_COUNT = gql`
  query GetProjectTasksCount($projectId: ID!) {
    projectTaskList(projectId: $projectId) {
      id
      tasksCount
      tasksCompletedCount
    }
  }
`;
const useGetAssetProjectTasks = ({ assetId, projectId }) => {
  const { data, loading, networkStatus, error } = useQuery(
    GET_ASSET_PROJECT_TASKS,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        id: assetId,
      },
    },
  );

  const { data: projectTaskData } = useQuery(GET_PROJECT_TASKS_COUNT, {
    variables: {
      projectId,
    },
  });

  const projectTasks = data?.projectTasksForResource ?? [];
  const totalProjectTasksCount =
    projectTaskData?.projectTaskList?.tasksCount ?? 0;

  const [completedTasks, incompleteTasks] = partition(
    projectTasks,
    'completed',
  );

  const { newTask, addNewTask, addNewTaskAtEnd, removeNewTask } =
    useNewProjectTask({
      lastPosition: totalProjectTasksCount,
      lastIndex: incompleteTasks.length,
    });

  return {
    incompleteTasks: combineExistingTasksWithNewTask({
      newTask,
      existingTasks: incompleteTasks,
    }),
    completedTasks,
    addNewTask,
    addNewTaskAtEnd,
    removeNewTask,
    networkStatus,
    loading,
    error,
  };
};

export default useGetAssetProjectTasks;
